import {
    Notification,
} from 'element-ui'
import {
    i18n,
} from '@/plugins/vuei8n'

const localState = {
    isUpdate: false,
    showModal: false,
    deleteModal: false,
    deletedId: null,
    badges: {
        main: null,
        funny: null,
        all: null,
    },
    badge: null,
    form: {
        icon: {
            file: null,
            text: '',
        },
        name: '',
        category: '',
    },
    masterBadges: null,
}

const mutations = {
    setState: (state, {
        key,
        value,
    }) => {
        state[key] = value
    },
    setBadge: (state, {
        key,
        value,
    }) => {
        state.badges[key] = value
    },
    clearModal: (state) => {
        state.form = {
            icon: {
                file: null,
                text: '',
            },
            name: '',
            category: '',
        }
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        try {
            const main = await this.$api.badges.fetch()
            // const funny = await this.$api.badges.fetch('?category=funny');

            // commit('setBadge', {
            //     key: 'main',
            //     value: main.data.data
            // });

            // commit('setBadge', {
            //     key: 'funny',
            //     value: funny.data.data
            // });

            commit('setBadge', {
                key: 'all',
                value: main.data.data,
            })
        } catch (err) {
            console.log(err)
        }
    },
    async fetchById({
        commit,
        state,
    }, id) {
        try {
            const response = await this.$api.badges.fetchById(id)

            commit('setState', {
                key: 'badge',
                value: response.data,
            })

            state.form.name = response.data.name
            state.form.category = response.data.category

            const filename = response.data.icon.split('/')
            state.form.icon.text = filename[filename.length - 1]
        } catch (err) {
            console.log(err)
        }
    },
    async remove({
        dispatch,
    }, id) {
        try {
            const response = await this.$api.badges.remove(id)

            if (response.status === 204) {
                Notification({
                    title: i18n.t('notifications.badgeDeleted'),
                    message: i18n.t('notifications.badgeDeletedText'),
                    duration: 5000,
                })
            }

            dispatch('fetch')
        } catch (err) {
            console.log(err)
        }
    },
    async toggle(_, id) {
        return await this.$api.badges.toggle(id)
    },
    async add({
        dispatch,
    }, form) {
        try {
            const response = await this.$api.badges.create(form)

            if (response.status === 201) {
                Notification({
                    title: i18n.t('notifications.badgeCreated'),
                    message: i18n.t('notifications.badgeCreatedText'),
                    duration: 5000,
                })
            }

            dispatch('fetch')
        } catch (err) {
            console.log(err)
        }
    },
    async update({
        dispatch,
    }, {
        form,
        id,
    }) {
        try {
            const response = await this.$api.badges.update(id, form)

            if (response.status === 200) {
                Notification({
                    title: i18n.t('notifications.badgeUpdated'),
                    message: i18n.t('notifications.badgeUpdatedText'),
                    duration: 5000,
                })
            }

            await dispatch('fetch')
        } catch (err) {
            console.log(err)
        }
    },
    async fetchMasterBadges({
        commit,
    }, id) {
        try {
            const response = await this.$api.specialists.fetchBadges(id)

            commit('setState', {
                key: 'masterBadges',
                value: response.data.data !== undefined ? [] : response.data,
            })
        } catch (err) {
            console.log(err)
        }
    },
    async saveBadges(_, {
        badges,
        id,
    }) {
        try {
            const response = await this.$api.specialists.saveBadges(id, {
                badges,
            })

            if (response.status === 200) {
                Notification({
                    title: i18n.t('notifications.badgesHandyman'),
                    message: i18n.t('notifications.badgesHandymanText'),
                    duration: 5000,
                })
            }
        } catch (err) {
            console.log(err)
        }
    },
}

const getters = {
    badges: (state) => state.badges,
    showModal: (state) => state.showModal,
    deleteModal: (state) => state.deleteModal,
    isUpdate: (state) => state.isUpdate,
    deletedId: (state) => state.deletedId,
    badge: (state) => state.badge,
    form: (state) => state.form,
    masterBadges: (state) => state.masterBadges,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
